/**
 * evil-badge-cta.js
 * Button-hide only. No animation in current build.
 * Full schema-reveal animation archived at:
 *   /mnt/user-data/outputs/evil-badge-cta-animation.js
 */

(function () {
  'use strict';

  /**
   * Hide Origin theme text buttons in the section immediately
   * preceding each badge CTA section.
   */
  function hideSiblingButtons() {
    document.querySelectorAll('.evil-badge-cta-wrap').forEach(function (wrap) {
      var badgeSection = wrap.closest('.shopify-section');
      if (!badgeSection) return;

      var btnSection = badgeSection.previousElementSibling;
      if (!btnSection) return;

      btnSection.querySelectorAll('a.button, button.button, [class*="button"]').forEach(function (el) {
        if (!el.closest('.evil-badge-cta')) {
          el.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSiblingButtons);
  } else {
    hideSiblingButtons();
  }

})();
